// Palette
import palette from '../palette'

export default {
  root: {
    backgroundColor: palette.background.light,
    color: '#425A70',
  },
  clickable: {
    '&:hover, &:focus, &:active': {
      backgroundColor: '#EDF0F2',
    },
  },
  deletable: {
    '&:focus': {
      backgroundColor: palette.background.light,
    },
  },
  outlined: {
    '&:hover': {
      backgroundColor: palette.background.light,
    },
  },
}
